// extracted by mini-css-extract-plugin
export default {"cardInfo":"TrendingCard_cardInfo__TQfWn","card":"TrendingCard_card__P7dvp","cardInfoItem":"TrendingCard_cardInfoItem__7SbsZ","moreButton":"TrendingCard_moreButton__qOWsh"};